module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', [_c('span', {
    staticStyle: {
      "line-height": "36px"
    }
  }, [_vm._v(_vm._s(_vm.list1Title))])]), _vm._v(" "), _c('draggable', {
    staticClass: "dragArea",
    attrs: {
      "options": _vm.dragOptions
    },
    on: {
      "end": _vm.updateList
    },
    model: {
      value: (_vm.list1),
      callback: function($$v) {
        _vm.list1 = $$v
      },
      expression: "list1"
    }
  }, _vm._l((_vm.list1), function(element) {
    return _c('div', {
      key: element.name,
      staticClass: "list-item"
    }, [_c('i', {
      staticClass: "fa fa-thumb-tack",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v("\n            " + _vm._s(element[_vm.displayedProperty]) + "\n          ")])
  }))], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', [_c('span', {
    staticStyle: {
      "line-height": "36px"
    }
  }, [_vm._v(_vm._s(_vm.list2Title))])]), _vm._v(" "), _c('draggable', {
    staticClass: "dragArea",
    attrs: {
      "options": _vm.dragOptions
    },
    on: {
      "end": _vm.updateList
    },
    model: {
      value: (_vm.list2),
      callback: function($$v) {
        _vm.list2 = $$v
      },
      expression: "list2"
    }
  }, _vm._l((_vm.list2), function(element) {
    return _c('div', {
      key: element.name,
      staticClass: "list-item"
    }, [_c('i', {
      staticClass: "fa fa-thumb-tack",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v("\n            " + _vm._s(element[_vm.displayedProperty]) + "\n          ")])
  }))], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e3dbd8fc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/widgets/draggablelist/index.vue
// module id = 770
// module chunks = 2